import React from "react";

const RefundBreakdownModal = ({
  selectedAttires,
  quantities,
  onUpdateQuantity,
  onProceed,
  onClose,
  refundQuantities,
  eventData,
}) => {
  const calculateTotal = () => {
    return selectedAttires.reduce((total, attire) => {
      return total + attire.price * refundQuantities[attire._id];
    }, 0);
  };

  const calculateAttireTotalPaid = (attire) => {
    return attire.price * attire.quantity;
  };

  const formatCurrency = (amount) => {
    const num = typeof amount === "string" ? parseFloat(amount) : amount;

    if (num === 0) {
      return "Free";
    }

    const currency = eventData?.preferredCurrency || "NGN";
    const symbol = currency === "NGN" ? "₦" : "$";
    return `${symbol}${num.toLocaleString()}`;
  };

  return (
    <div className="other-purchase-modal-overlay">
      <div className="other-purchase-modal-content attire-modal-large">
        <button onClick={onClose} className="modal-close-button">
          <span>X</span>
        </button>

        <h2>Refund Attire Breakdown</h2>
        <p className="purchase-modal-subtitle">
          Review selected attires and adjust quantities before continuing
        </p>

        <div className="attire-breakdown-list">
          {selectedAttires.map((attire) => (
            <div key={attire._id} className="attire-breakdown-item">
              <img
                src={attire.uri}
                alt={attire.attireTag}
                className="attire-breakdown-image"
              />
              <div className="attire-breakdown-info">
                <p className="refund-summary-attire-name">{attire.attireTag}</p>

                <p className="refund-summary-attire-price">
                  {formatCurrency(attire.price)} × {attire.quantity}
                </p>

                <p className="refund-summary-attire-total">
                  Paid: {formatCurrency(calculateAttireTotalPaid(attire))}
                </p>
              </div>

              <div className="quantity-slider">
                <button
                  onClick={() =>
                    onUpdateQuantity(attire._id, quantities[attire._id] - 1)
                  }
                  disabled={quantities[attire._id] <= 1}
                >
                  −
                </button>
                <span>
                  Refund: {quantities[attire._id]} / {attire.quantity}
                </span>
                <button
                  onClick={() =>
                    onUpdateQuantity(attire._id, quantities[attire._id] + 1)
                  }
                  disabled={quantities[attire._id] >= attire.quantity}
                >
                  +
                </button>
              </div>
            </div>
          ))}
          <div className="total-attire-details-row">
            <p className="total-price-label">Total: </p>
            <p className="total-price-style">
              {formatCurrency(calculateTotal())}
            </p>
          </div>
        </div>

        <div className="modal-controls">
          <button
            type="button"
            className="modal-button other-purchase-cancel"
            onClick={onClose}
          >
            Close
          </button>

          <button
            type="button"
            className="modal-button proceed-button"
            onClick={() => onProceed()}
          >
            Proceed
          </button>
        </div>
      </div>
    </div>
  );
};

export default RefundBreakdownModal;
